import { DialogType } from '@tableau/widgets';
import React from 'react';

import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';

import { ModalInstance, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { AddActiveDirectoryServerUsersDialog } from '../components/AddActiveDirectoryServerUsersDialog';
import { AddActiveDirectorySiteUsersDialog } from '../components/AddActiveDirectorySiteUsersDialog';

const serverAndSiteUsersDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: '18px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  paddingRight: '12px'
};

function showAddActiveDirectoryUsersToSiteDialog(availableQuota: number, identityPool?: IIdentityPool): Promise<any> {
  let modalInstance: ModalInstance;
  const dialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss(),
    close: (result: any) => modalInstance && modalInstance.close(result),
    availableQuota: availableQuota,
    identityPool: identityPool,
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(AddActiveDirectorySiteUsersDialog, dialogProps),
    testId: 'addActiveDirectorySiteUsersDialog',
    showCloseButton: true,
    dialogStyle: serverAndSiteUsersDialogStyle,
    shouldNotSetDefaultWidth: true
  });

  return modalInstance.result;
}

function showAddActiveDirectoryUsersToServerDialog(identityPool?: IIdentityPool): Promise<any> {
  let modalInstance: ModalInstance;
  const dialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss(),
    close: (result: any) => modalInstance && modalInstance.close(result),
    identityPool: identityPool,
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(AddActiveDirectoryServerUsersDialog, dialogProps),
    testId: 'addActiveDirectoryServerUsersDialog',
    showCloseButton: true,
    dialogStyle: serverAndSiteUsersDialogStyle,
    shouldNotSetDefaultWidth: true
  });

  return modalInstance.result;
}

export const AddActiveDirectoryUsersAction = {
  showAddActiveDirectoryUsersToSiteDialog, showAddActiveDirectoryUsersToServerDialog
};
